import CustomDrawer from "@/components/drawer";
import useScheduleStore from "@/store/schedule";
import {
  ActionIcon,
  Button,
  DirectionProvider,
  Group,
  Pill,
  Stack,
  Text,
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import {
  IconCalendar,
  IconFilter,
  IconInfoOctagon,
  IconMenu2,
} from "@tabler/icons-react";
import moment from "moment-jalaali";
import { useNavigate } from "react-router-dom";
import SelectFromCalendar from "../calendar";
import FilterMerchantService from "../filterMerchantService";
import ScheduleSideBar from "./components/sideBar";

type Props = {
  handleClickStart: () => void;
};

function ScheduleHeader({ handleClickStart }: Props) {
  const [opened, { open, close }] = useDisclosure(false);
  const [openedFilter, { open: filterOpen, close: filterClose }] =
    useDisclosure(false);
  const [openedCalender, { open: openCalender, close: closeCalender }] =
    useDisclosure(false);
  const navigate = useNavigate();
  const {
    selectedDate,
    setDate,
    merchantServiceFilters,
    setMerchantServiceFilters,
  } = useScheduleStore();

  const removeFilter = (id: number) => {
    setMerchantServiceFilters({
      merchantServiceFilters: merchantServiceFilters?.filter(
        (x) => x.id !== id
      ),
    });
  };

  const isToday =
    new Date().getDate() === new Date(new Date(selectedDate))?.getDate();

  return (
    <>
      <Group justify="space-between">
        <ActionIcon variant="transparent" color="gray" id="menu">
          <IconMenu2 onClick={open} stroke={1} />
        </ActionIcon>
        <Group gap="5" justify="center" align="center">
          {isToday && (
            <Text c="blue" size="md">
              امروز ،
            </Text>
          )}
          <Text size="sm">
            {moment(selectedDate).format("dddd jD jMMMM jYYYY")}
          </Text>
        </Group>
        <Group gap={3}>
          <ActionIcon
            variant="transparent"
            color="gray"
            onClick={handleClickStart}
          >
            <IconInfoOctagon stroke={1} />
          </ActionIcon>
          <ActionIcon
            variant="transparent"
            color="gray"
            onClick={openCalender}
            id="select-day"
          >
            <IconCalendar stroke={1} />
          </ActionIcon>
        </Group>
      </Group>
      <Group justify="space-between" wrap="nowrap">
        <Group wrap="nowrap">
          <ActionIcon
            size="md"
            c="gray"
            variant="transparent"
            onClick={filterOpen}
          >
            <IconFilter stroke={1} />
          </ActionIcon>
          <Group gap="xs">
            {merchantServiceFilters?.map((item) => (
              <Pill
                key={item?.id}
                withRemoveButton
                removeButtonProps={{
                  onClick: () => removeFilter(item?.id || 0),
                }}
                size="xs"
              >
                {item?.title}
              </Pill>
            ))}
          </Group>
        </Group>

        <Button
          id="add-appointment"
          variant="light"
          size="compact-xs"
          onClick={() => navigate("add")}
          w="120px"
        >
          افزودن نوبت +
        </Button>
      </Group>
      <DirectionProvider initialDirection="rtl">
        <CustomDrawer
          position="left"
          opened={opened}
          close={close}
          onClose={close}
          size="80%"
          custom="scheduleMenu"
        >
          <ScheduleSideBar close={close} />
        </CustomDrawer>
      </DirectionProvider>
      <CustomDrawer
        opened={openedCalender}
        close={closeCalender}
        onClose={closeCalender}
        position="bottom"
        title="انتخاب تاریخ"
      >
        <Stack pt="md">
          <SelectFromCalendar
            close={closeCalender}
            setDate={(e) =>
              setDate({
                selectedDate: e,
              })
            }
          />
        </Stack>
      </CustomDrawer>
      <CustomDrawer
        opened={openedFilter}
        close={filterClose}
        onClose={filterClose}
        position="bottom"
        title="فیلتر"
        custom="filterClose"
      >
        <FilterMerchantService close={filterClose} />
      </CustomDrawer>
    </>
  );
}

export default ScheduleHeader;
